import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Modal } from 'fpay-ui';
import { useTranslation, Trans } from 'react-i18next';
import parse from 'html-react-parser';
import { ModalToRedirect, BlockScreenCard } from '@components';
import Image from '@components/Image';
import { SETTLEMENT_CALENDAR } from '@constants/routes';
import { moneyFormat } from 'helpers';
import { CAUSES } from '@constants/blockings';

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    background-color: ${theme.colors.gray200};
  `
);

const BoxContainer = styled.div(
  () => css`
    width: auto;
    display: inline-block;
    border-radius: 10px;
  `
);

const StyledDiv = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    width: 600px;
    flex-grow: 0;
    border-radius: 6px;
    ${({ theme }) => theme.newBreakpoint('md')} {
      width: 600px;
    }
    ${({ theme }) => theme.newBreakpoint('sm')} {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }
  `
);

const StyledTitle = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Title-w700']}
    margin-top: 32px;
  `
);

const StyledSubtitle = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Subtitle-1-w500']}
    margin-bottom: 32px;
  `
);

const StyledDescription = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Description-w700']}
    margin-bottom: 24px;
  `
);

const StyledContentIcon = styled.div(
  () => css`
    background: #fce6ec;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 72px;
    border-radius: 6px;
  `
);

const StyledIcon = styled(Image)`
  width: 40px;
  height: 40px;
`;

export const BlockScreen = ({ blockingDetails }) => {
  const { t } = useTranslation();

  const [showModalToRedirect, setShowModalToRedirect] = useState(false);
  const toggleShowModalToRedirect = () => {
    setShowModalToRedirect((prev) => !prev);
  };
  return (
    <Layout>
      <BoxContainer>
        <StyledDiv>
          <StyledContentIcon>
            <StyledIcon src="tooltip-alert.svg" />
          </StyledContentIcon>
          <StyledTitle>{t('blockScreen.title')}</StyledTitle>
          <StyledSubtitle>
            <Trans i18nKey="blockScreen.subtitle" />
          </StyledSubtitle>
          <StyledDescription>
            <Trans
              i18nKey={t('blockScreen.description', {
                amount: `${moneyFormat(blockingDetails.amount).toString()}`,
                product: CAUSES[blockingDetails.cause] || 'al producto',
              })}
            />
          </StyledDescription>
          <BlockScreenCard
            number="1"
            title={t('blockScreen.infoCards.0.title')}
            firstDescription={t('blockScreen.infoCards.0.description.0')}
            SecondDescription={t('blockScreen.infoCards.0.description.2')}
            textToLink={t('blockScreen.infoCards.0.description.1')}
            urlToGo={SETTLEMENT_CALENDAR}
          />
          <BlockScreenCard
            number="2"
            title={t('blockScreen.infoCards.1.title')}
            firstDescription={t('blockScreen.infoCards.1.description')}
            buttonText={t('blockScreen.infoCards.1.buttonText')}
            onClick={() => setShowModalToRedirect(true)}
          />
        </StyledDiv>
      </BoxContainer>
      {showModalToRedirect && (
        <Modal fClose={toggleShowModalToRedirect} showCloseButton={false} width="400px">
          <ModalToRedirect
            text={parse(t('blockScreen.modalToRedirect.subTitle'))}
            link={t('blockScreen.modalToRedirect.linkToBank')}
            handleCancel={() => setShowModalToRedirect(false)}
            textConfirm={t('blockScreen.modalToRedirect.textConfirm')}
            textCancel={t('blockScreen.modalToRedirect.textCancel')}
          />
        </Modal>
      )}
    </Layout>
  );
};

export default BlockScreen;
